import { Box, Text } from '@chakra-ui/react';
import ManageScheduleSlot from './ManageScheduleSlot';

const data = [
    {order: 1, title: 'Aca',color:'#7958c9' },
    { order: 2, title: 'Webbrain',color:'#26c383' },
    { order: 3, title: 'Webbrain',color:"#fa5b59" },
    { order: 4, title: 'Webbrain',color:'#4682af' },
    { order: 5, title: 'Webbrain',color:"#26c383" },
    { order: 6, title: 'Webbrain',color:'#7958c9' },
    { order: 7, title: 'Webbrain',color:"#26c383" },
    { order: 8, title: 'Webbrain',color:'#fa5b59' },
    { order: 9, title: 'Webbrain',color:"#4682af" }, 
];



export default function ManageScheduleRow({ session, time, id,color }) {
  console.log(session);
  return (
    <Box
      width='100%'
      display='flex'
      justifyContent='space-between'
      alignItems='center'
      ml='0.6rem'
      
    >
      <Box
        flex='1'
        display='flex'
        justifyContent='center'
        alignItems='center'
        color='#F25C3A'
        style={{ fontFamily: 'Mulish, sans-serif' }}
        height='100%'
      >
        <Text
          fontStyle='normal'
          lineHeight='18px'
          fontSize='16px'
          fontWeight='700'
          color='#999999'
          style={{ fontFamily: 'Mulish, sans-serif'  }}
        >
          {time}
        </Text>
      </Box>
      {session.map((row, idx) => (
        <ManageScheduleSlot
          time={time}
          key={idx}
          id={row ? row.schedule_id : null}
          subject={row ? row.subject_name : null}
          className={row ? row.class_name : null}
          sessionId={row ? row.session_id : null}
          categoryId={row ? row.category_id : null}
          categoryTitle={row ? row.category_title : null}
          libraryId={row ? row.library_id : null}
          libraryTitle={row ? row.library_title : null}
          data={data[idx]["order"]}
          colorName={data[idx]["color"]}
          contentUrl={row ? row.library_url : null}
        />
      ))}
    </Box>
  );
}
